



















import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { formatValidationErrors } from '@/components/proff/utils/validator';

export default Vue.extend({
  components: {
    ValidationObserver,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
  },
  computed: {
    errors(): InstanceType<typeof ValidationObserver>['errors'] {
      const observer = this.$refs.observer as InstanceType<
        typeof ValidationObserver
      >;
      return observer ? observer.errors : {};
    },
    errorMessages(): string[] {
      return formatValidationErrors(this.errors);
    },
  },
  methods: {
    formatValidationErrors,
  },
});
